import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useChildTokens } from './useChildTokens';

/**
 * 🔥N dagar-kort (prototypens .streak-card). Visar barnets nuvarande streak.
 * Värdet kommer från StarContext (streak.currentStreak).
 *
 * Skamfri statusmodell (Pipeline 1): vid streak > 0 visas den positiva gröna
 * presentationen (🔥, uppmuntran). Vid streak <= 0 (ingen pågående svit, eller
 * en bruten sådan) visas en NEUTRAL "ny start"-variant (🌱) utan förlust- eller
 * skamton — bara värdena villkoras, strukturen är oförändrad.
 */
type StreakCardProps = {
  currentStreak: number;
};

const StreakCard = ({ currentStreak }: StreakCardProps) => {
  const { t } = useTranslation();
  const tokens = useChildTokens();
  const active = currentStreak > 0;

  return (
    <Box
      sx={{
        bgcolor: active ? tokens.greenLight : tokens.mutedLight,
        border: '2px solid',
        borderColor: active ? 'success.main' : tokens.muted,
        borderRadius: '16px',
        p: '16px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Box aria-hidden sx={{ fontSize: '2rem' }}>
        {active ? '🔥' : '🌱'}
      </Box>
      <Box>
        <Typography
          sx={{ fontWeight: 900, fontSize: '1.2rem', color: active ? 'success.main' : tokens.text }}
        >
          {active
            ? t('child.stars.streakDays', { count: currentStreak })
            : t('child.stars.streakFreshStart')}
        </Typography>
        <Typography sx={{ fontSize: '0.85rem', color: tokens.textSoft, fontWeight: 600 }}>
          {active ? t('child.stars.streakEncourage') : t('child.stars.streakFreshStartSub')}
        </Typography>
      </Box>
    </Box>
  );
};

export default StreakCard;
